import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader,
  MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import { startOfMonth, addMonths } from 'date-fns';
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import { LoadingComponent } from './../../../../utils/newLoader';
import TablePagination from '@material-ui/core/TablePagination';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const screenCode = 'FACTORYITEMDETAILINSTALMENTREPORT';

export default function FactoryItemDetailInstalmentReport(props) {
  const [title, setTitle] = useState("Factory Item Detail Installment Report");
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routeList, setRouteList] = useState();
  const [ItemCategoryList, setItemCategoryList] = useState();
  const [factoryItems, setFactoryItems] = useState();
  const [itemRequestDetail, setItemRequestDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    registrationNumber: '',
    itemCategoryID: 0,
    factoryItemID: 0,
  });
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);

  const [factoryItemList, setFactoryItemList] = useState([]);

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    startDate: '',
    endDate: '',
    routeName: "0",
    factoryItemName: "0",
    itemCategoryName: "0"
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [MonthList, setMonthList] = useState([]);
  const [DynemicMonthNameList, setDynemicMonthNameList] = useState([])

  useEffect(() => {
    ColumnCreate();
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
    trackPromise(getAllActiveItemCategory())
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [itemRequestDetail.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID());
  }, [itemRequestDetail.factoryID]);

  useEffect(() => {
    trackPromise(
      getfactoryItemsForDropDown());
  }, [itemRequestDetail.groupID, itemRequestDetail.factoryID, itemRequestDetail.itemCategoryID]);

  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      registrationNumber: '',
      itemCategoryID: 0,
      factoryItemID: 0,
    })
  }, [itemRequestDetail.routeID])

  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      registrationNumber: '',
      factoryItemID: 0,
    }
    )
  }, [itemRequestDetail.itemCategoryID])

  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      registrationNumber: '',
      itemCategoryID: 0,
      factoryItemID: 0,
    })
  }, [itemRequestDetail.factoryID])

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYITEMDETAILINSTALMENTREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setItemRequestDetail({
      ...itemRequestDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(itemRequestDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(itemRequestDetail.factoryID);
    setRouteList(routes);
  }

  async function getAllActiveItemCategory() {
    const result = await services.getAllActiveItemCategory();
    setItemCategoryList(result);
  }

  async function getfactoryItemsForDropDown() {
    const factoryItem = await services.getfactoryItemsByGroupIDFactoryIDItemCategoryID(itemRequestDetail.groupID, itemRequestDetail.factoryID, itemRequestDetail.itemCategoryID);
    setFactoryItems(factoryItem);
  }

  async function GetFactoryItemDetailsInstallmentsData() {
    let model = {
      groupID: parseInt(itemRequestDetail.groupID),
      factoryID: parseInt(itemRequestDetail.factoryID),
      routeID: parseInt(itemRequestDetail.routeID),
      itemCategoryID: parseInt(itemRequestDetail.itemCategoryID),
      factoryItemID: parseInt(itemRequestDetail.factoryItemID),
      registrationNumber: itemRequestDetail.registrationNumber,
    }
    getSelectedDropdownValuesForReport(model);
    let response = await services.GetFactoryItemDetailsInstallmentsForReport(model)

    if (response.statusCode == "Success" && response.data != null) {

      let installmentsMonthArray = [];

      for (let item of response.data) {
        let regNumber = item.registrationNumber;
        let affectedMonth = item.paymentEffectedMonth;
        let totalPrice = item.totalPrice;
        let noOfInstallment = item.noOfInstallments;
        let approvedQuantity = item.approvedQuantity;
        let categoryName = item.categoryName;
        let date = item.date;
        let itemName = item.itemName;
        let name = item.name;
        let routeName = item.routeName;
        let perInstallmentPrice = parseFloat((totalPrice / noOfInstallment).toFixed(2));
        let paymentAffectMonthArray = [];

        for (let i = 0; i < noOfInstallment; i++) {
          let newMonth = parseInt(affectedMonth) + i;
          paymentAffectMonthArray.push({
            affectedMonth: newMonth,
            perInstallmentPrice: perInstallmentPrice,
          });
        }

        installmentsMonthArray.push({
          registrationNumber: regNumber,
          affectedMonth: affectedMonth,
          totalPrice: totalPrice,
          perInstallmentPrice: perInstallmentPrice,
          noOfInstallment: noOfInstallment,
          approvedQuantity: approvedQuantity,
          categoryName: categoryName,
          date: date,
          itemName: itemName,
          name: name,
          routeName: routeName,
          paymentAffectMonthArray: paymentAffectMonthArray,
        });
      }

      setFactoryItemList(installmentsMonthArray);
      createDataForExcel(installmentsMonthArray);
      if (response.data.length == 0) {
        alert.error("No records to display");
      }
    }
    else {
      alert.error(response.message);
    }
  }

  async function createDataForExcel(factoryItemList) {
    var res = [];
    if (factoryItemList != null && Array.isArray(factoryItemList)) {
      const currentDate = new Date();
      const monthNames = [];

      for (let i = 0; i < 3; i++) {
        const date = new Date(currentDate.getFullYear(), currentDate.getMonth() + i, 1);
        monthNames.push(date.toLocaleString('default', { month: 'long' }));
      }

      factoryItemList.map(item => {
        const monthPayments = {};
        item.paymentAffectMonthArray.forEach(payment => {
          monthPayments[payment.affectedMonth] = payment.perInstallmentPrice;
        });

        const currentMonth = currentDate.getMonth() + 1;
        const monthNumbers = [
          currentMonth % 12 || 12,
          (currentMonth + 1) % 12 || 12,
          (currentMonth + 2) % 12 || 12
        ];

        const vr = {
          'Route Name': item.routeName || '',
          'Date': item.date ? item.date.split('T')[0] : '',
          'Reg No': item.registrationNumber || '',
          'Supplier Name': item.name || '',
          'Category': item.categoryName || '',
          'Item': item.itemName || '',
          'Quantity': item.approvedQuantity || 0
        };

        monthNumbers.forEach((monthNum, index) => {
          const payment = monthPayments[monthNum];
          vr[monthNames[index]] = payment ? payment : '-';
        });

        vr['Total Price (Rs)'] = item.totalPrice ?
          Number(item.totalPrice) :
          '-';

        res.push(vr);
      });

      res.push([]);
      var vr = {
        'Route Name': 'Group- ' + selectedSearchValues.groupName,
        'Date': 'Factory - ' + selectedSearchValues.factoryName
      };
      res.push(vr);

      var vr = {
        'Route Name': selectedSearchValues.itemCategoryName === undefined ? 'Item category - All Item Categories' : 'Item category - ' + selectedSearchValues.itemCategoryName,
        'Date': selectedSearchValues.factoryItemName === undefined ? 'Factory items - All factory items' : 'Factory items - ' + selectedSearchValues.factoryItemName,
      };
      res.push(vr);
      var vr = {
        'Route Name': selectedSearchValues.routeName === undefined ? 'Route - All Route' : 'Route - ' + selectedSearchValues.routeName,
      };
      res.push(vr);
    }
    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(factoryItemList);
    var settings = {
      sheetName: 'Factory Item Installment Report',
      fileName: 'Factory Item Detail Installments Report ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName,
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataModel = [
      {
        sheet: 'Factory Item Installment Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataModel, settings);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setItemRequestDetail({
      ...itemRequestDetail,
      [e.target.name]: value
    });
    setFactoryItemList([]);
  }
  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  function ColumnCreate() {
    let columnNameArray = [
      { title: 'Route Name', field: 'routeName' },
      { title: 'Date', field: 'date', render: rowData => rowData.date.split('T')[0] },
      { title: 'Reg No', field: 'registrationNumber' },
      { title: 'Supplier Name', field: 'name' },
      { title: 'Category', field: 'categoryName' },
      { title: 'Item', field: 'itemName' },
      { title: 'Quantity', field: 'approvedQuantity' }
    ]

    let monthNameList = []

    for (let index = 0; index <= 2; index++) {
      let startDate = startOfMonth(addMonths(new Date(), index))
      const month = startDate.toLocaleString('default', { month: 'long' });
      monthNameList.push({ title: month, field: month.toLowerCase() })
      columnNameArray.push({ title: month, field: month.toLowerCase() })
    }
    columnNameArray.push({ title: 'Total Price (Rs)', field: 'totalPrice', render: rowData => rowData.totalPrice })
    setDynemicMonthNameList(monthNameList)
    setMonthList(columnNameArray);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      routeName: routeList[searchForm.routeID],
      itemCategoryName: ItemCategoryList[searchForm.itemCategoryID],
      factoryItemName: factoryItems[searchForm.factoryItemID]
    });
  }

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const getPageMargins = () => {
    return `@media print {
            @page {
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: itemRequestDetail.groupID,
              factoryID: itemRequestDetail.factoryID
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
              })
            }
            onSubmit={() => trackPromise(GetFactoryItemDetailsInstallmentsData())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routeList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="itemCategoryID">
                              Item Category
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="itemCategoryID"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.itemCategoryID}
                              size='small'
                              variant="outlined" >
                              <MenuItem value={0}>--Select Item Category--</MenuItem>
                              {generateDropDownMenu(ItemCategoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryItemID">
                              Factory Item
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="factoryItemID"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.factoryItemID}
                              variant="outlined"
                              id="factoryItemID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory Item--</MenuItem>
                              {generateDropDownMenu(factoryItems)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="registrationNumber"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                              size='small'
                            >
                            </TextField>
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2} >
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      {factoryItemList.length > 0 ?
                        <Box minWidth={1050}>
                          <TableContainer>
                            <Table aria-label="caption table" size="small">
                              <TableHead>
                                <TableRow>
                                  {
                                    MonthList.map((object) => {
                                      return (
                                        <TableCell style={{ border: 'solid 1px #ccc' }} align={'center'}>{object.title}</TableCell>
                                      )
                                    })
                                  }
                                </TableRow>
                              </TableHead>
                              <TableBody style={{ border: 'solid 1px #ccc' }}>
                                {factoryItemList.slice(page * limit, page * limit + limit).map((data, index) => {
                                  const monthPayments = {};
                                  data.paymentAffectMonthArray.forEach(payment => {
                                    monthPayments[payment.affectedMonth] = payment.perInstallmentPrice;
                                  });

                                  return (
                                    <TableRow key={index}>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                                        {data.routeName}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                                        {data.date.split('T')[0]}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                                        {data.registrationNumber}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                                        {data.name}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                                        {data.categoryName}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                                        {data.itemName}
                                      </TableCell>
                                      <TableCell align={'right'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                                        {data.approvedQuantity}
                                      </TableCell>
                                      {MonthList.slice(7, 10).map((month, i) => {
                                        const currentDate = new Date();
                                        const monthNumber = (currentDate.getMonth() + 1 + i) % 12 || 12;
                                        const payment = monthPayments[monthNumber];

                                        return (
                                          <TableCell
                                            key={i}
                                            align={'right'}
                                            component="th"
                                            scope="row"
                                            style={{ border: 'solid 1px #ccc' }}
                                          >
                                            {payment ? payment.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                          </TableCell>
                                        );
                                      })}
                                      <TableCell align={'right'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                                        {data.totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <TablePagination
                            component="div"
                            count={factoryItemList.length}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handleLimitChange}
                            page={page}
                            rowsPerPage={limit}
                            rowsPerPageOptions={[5, 10, 25]}
                          />
                        </Box>
                        : null}
                      {factoryItemList.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                            size='small'
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={"Factory Item Details Installments Report"}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                              size='small'
                            >
                              PDF
                            </Button>}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              factoryItemList={factoryItemList}
                              searchData={selectedSearchValues}
                              columnNames={MonthList}
                            />
                          </div>

                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}